
<template>
  <div id="daftar-pelaporan" class="content content--borderless">
    <div class="content__breadcrumbs">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
    </div>
    <div class="content__header">
      <div class="content__main-header">
        <div class="content__title">
          <div class="content__title__name">Daftar Pelaporan <span class="text-primary ml-1">Metadata Statistik</span></div>
          <div class="content__title__description">Daftar semua pelaporan metadata statistik kegiatan yang telah diinput. Klik icon mata untuk melihat detail MS-Kegiatan, MS-Variabel dan MS-Indikator</div>
        </div>
        <div class="ml-auto d-flex">
          <b-dropdown id="dropdown-dropup" text="Drop-Up"  class="m-2" toggle-class="button px-2 button--sm button--outlined text-nowrap">
            <template #button-content>
                <VueFeather type="clock" size="14" stroke-width="2" style="display:nlock"></VueFeather> &nbsp; Periode: <span class="text-bold pl-1">{{submissionPeriod}}</span>
            </template>
            <b-dropdown-item  
              v-for="(period , index) in options.submissionPeriod" :key="index" 
              :active="submissionPeriod == period" 
              @click="submissionPeriod = period; getSummaryMetadata();" 
            >
                {{period}}
            </b-dropdown-item>
          </b-dropdown>
          
        </div>
      </div>
      
    </div>
    <div class="content__body mt-3 pb-5 form form--sm">
      <div class="table-search">
        <b-input-group>
          <b-input-group-prepend is-text class="bg-none">
            <VueFeather type="search" size="16" stroke-width="3" stroke="#919191"></VueFeather>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            debounce="500"
            v-model="filter.name"
            placeholder="Cari nama kegiatan . . ."
            class="border-left-0"
          ></b-form-input>
        </b-input-group>
        <button type="button" class="button" variant="primary" size="sm" @click="showModalFilter">
          <VueFeather type="filter" size="13" class="button__icon"></VueFeather>
          Filter <span class="button__count" v-if="filterCount>0">{{ filterCount }}</span>
        </button>
      </div>
      <div class="table-filter" v-if="filterCount>0">
        <div class="tags">
          <div class="tag tag--quinary" v-if="tagsFilter.statisticType">
            <div class="tag__field">Jenis Statistik</div>
            <div class="tag__value">{{ options.statisticType.find(x=>x.value == tagsFilter.statisticType).text }}</div>
            <div class="tag__remove" v-on:click="()=>{
              filter.statisticType = null;
              tagsFilter.statisticType = null;
              getSummaryMetadata();
            }">x</div>
          </div>
          <div class="tag tag--secondary" v-if="tagsFilter.status">
            <div class="tag__field">Status</div>
            <div class="tag__value">{{ options.status.find(x=>x.id == tagsFilter.status).label }}</div>
            <div class="tag__remove" v-on:click="()=>{
              filter.status = null;
              tagsFilter.status = null;
              getSummaryMetadata();
            }">x</div>
          </div>
          <div class="tag tag--senary" v-if="tagsFilter.produsenData">
            <div class="tag__field">Pengusul</div>
            <div class="tag__value">{{tagsFilter.produsenData.name}}</div>
            <div class="tag__remove" v-on:click="()=>{
              filter.produsenData = null;
              tagsFilter.produsenData = null;
              getSummaryMetadata();
            }">x</div>
          </div>
        </div>
      </div>
      <div class="table-wrapper" :style="filterCount==0? 'margin-top:15px':''">
        <b-table show-empty  class="table--light" :items="dataMetadataStatistikKegiatan" :fields="fieldsMetadata">
          <template #cell(no)="data"> {{10 * (currentPageMetadataStatistikKegiatan - 1) + data.index + 1}}.</template>
  
          <template #cell(created_at)="data">{{ data.item.created_at | formatDate }} </template>
          
          <template #cell(statistic_type)="data">
            {{data.value == 'STATISTIK_DASAR' ? 'Statistik Dasar' : (data.value == 'STATISTIK_SEKTORAL' ? 'Statistik Sektoral': 'Statistik Khusus')}}
          </template>
          
          <template #cell(status)="data">
            <span v-html="getBadge(data.item.status)"></span>
          </template>
          
          <template #cell(tahun)="data">
            {{data.item.data.tahun}}
          </template>
          
          <template #cell(created_by)="data">
            <div>{{data.item.requester_details ? data.item.requester_details.name : data.item.requested_by}}</div>
            <div v-if="data.item.requester_details && data.item.requester_details.organization" class="text-10 text-600 text-wrap">
              {{data.item.requester_details.organization.name}}
            </div>
          </template>
          
          <template #cell(aksi)="data">
              <div class="d-flex justify-content-center align-items-center">
                <b-link  class="button button--action button--action--view " v-b-tooltip.hover title="Lihat detail" :to="'/metadata/view-kegiatan/'+data.item.id">
                  <VueFeather type="eye" size="14"></VueFeather>
                </b-link>
                <b-link  class="button button--action button--action--edit "
                  v-b-tooltip.hover
                  :title="editTooltip(data.item)"
                  :disabled="editDisabled(data.item)"
                  :to="'/metadata/update-kegiatan/'+data.item.id"
                >
                  <VueFeather type="edit-3" size="14"></VueFeather>
                </b-link>
                <b-link  class="button button--action button--action--delete"
                  v-b-tooltip.hover
                  :title="deleteTooltip(data.item)"
                  :disabled="deleteDisabled(data.item)"
                  @click="()=>{deletedId = data.item.id;$bvModal.show('modal-delete')}">
                  <VueFeather type="x" size="14"></VueFeather>
                </b-link>

                <div class="border-right mx-2" style="height:18px"></div>
                <b-link
                  class="button button--action button--action--view " v-b-tooltip.hover title="Tambah siklus baru untuk kegiatan ini"
                  :disabled="data.item.status == 'DRAFT' "
                  @click="()=>{siklusId = data.item.id;$bvModal.show('modal-siklus')}">
                  <VueFeather type="rotate-cw" size="14"></VueFeather>
                </b-link>

                <div class="border-right mx-2" style="height:18px"></div>
                <b-dropdown id="dropdown-download" dropup right toggle-class="button button--action button--action--edit" no-caret>
                  <template #button-content>
                    <VueFeather type="download" size="14"></VueFeather>
                  </template>
                  <b-dropdown-item @click="download(data.item, 'excel')">Excel</b-dropdown-item>
                  <b-dropdown-item @click="download(data.item, 'pdf')">Pdf</b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
            <template #empty>
              <div class="table__empty">
                <div v-if="isLoading">
                  <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                <div v-else>
                  <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                    Tidak ada data yang tersedia
                </div>
              </div>
            </template> 
        </b-table>
        <div class="pagination-wrapper">
          <b-pagination
            class="mt-3 "
            align="center"
            v-model="currentPageMetadataStatistikKegiatan"
            :total-rows="rowsMetadataStatistikKegiatan"
            :per-page="perPage"
          ></b-pagination>
          <div class="pagination__goto ml-auto">Go to Page &nbsp;&nbsp;
            <b-form-input type="number" debounce="500" size="sm" v-model="goto"></b-form-input>
          </div>
        </div>
      </div>
    </div>
  
    <b-modal  hide-header hide-footer id="modal-delete" size="sm" content-class="p-0 modal modal--confirmation text-center" >
      <div class="px-2 pb-3 pt-0 mx-3 mt-0 my-2" style="border-radius:3px">
        <div >
          <img src="@/assets/img/delete.svg" width="200" height="200" alt="" />
        </div>
        <div class="text-center text-14 text-semi-bold" style="margin-top:-20px">
          Apakah anda yakin menghapus item ini?
        </div>
        <div class="text-12 text-700">
          Ketika dihapus, item tidak bisa dikembalikan lagi, kecuali anda melakukan input ulang
        </div>
        <div class="mt-4 mb-1 d-flex justify-content-center">
          <b-button class="button button--outlined mr-2" v-on:click="()=>{$bvModal.hide('modal-delete');}">Batal</b-button>
          <b-button class="button button--danger" @click="deleteMsKeg">Hapus</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal  hide-header hide-footer id="modal-siklus" size="md" content-class="p-0 modal modal--confirmation" >
      <div class="px-3 pb-3 pt-3 mx-1 mt-0 my-2" style="border-radius:3px">
        <div v-if="cycleStep === 'confirm'">
          <div class="text-left text-14 text-semi-bold">
            Tambah Siklus Baru
          </div>
          <div class="text-left text-12 text-700">
            Pilih metadata untuk ditambahkan pada siklus baru kegiatan
          </div>
          <template v-if="siklusItem">
          <div class="text-left d-flex flex-column mt-3">
              <div class="d-flex flex-column">
                <span class="text-12 text-700">Judul Kegiatan</span>
                <span class="text-13">{{ siklusItem.data.judul_kegiatan!==undefined?siklusItem.data.judul_kegiatan:siklusItem.data.judulKegiatan }}</span>
              </div>
              <div class="d-flex flex-column">
              <span class="text-12 text-700">Instansi Penyelenggara</span>
              <span class="text-13">{{ siklusItem.data.blok_i!==undefined?siklusItem.data.blok_i.instansi_penyelanggara:siklusItem.data.blokI.instansiPenyelanggara }}</span>
            </div>
            <div class="d-flex flex-column">
              <span class="text-12 text-700">Jumlah Metadata Variabel</span>
              <span class="text-13">{{ siklusItem.ms_var.length }} Metadata</span>
            </div>
            <div class="d-flex flex-column">
              <span class="text-12 text-700">Jumlah Metadata Indikator</span>
              <span class="text-13">{{ siklusItem.ms_ind.length }} Metadata</span>
            </div>
            </div>
            </template>
            <div v-else class="mt-3 text-center">
            <img src="@/assets/icons/loading-plane.gif" width="150" height="150"/>
            <div class="text-12">
              Sedang mengambil data ke server, harap tunggu sebentar....
            </div>
          </div>
          <div class="mt-4 mb-1 d-flex justify-content-center">
            <b-button class="button button--outlined mr-2" v-on:click="()=>{$bvModal.hide('modal-siklus');resetCycleStep();}">Batal</b-button>
            <b-button class="button button--primary" @click="createNewCycle()" :disabled="!siklusItem">Tambah</b-button>
          </div>
        </div>

        <div v-else-if="cycleStep === 'processing' || cycleStep === 'done'">
          <div class="text-left text-14 text-semi-bold">
            Proses Tambah Siklus Baru
          </div>
          <div class="text-left text-12 text-700 mb-2">
            Log proses penyimpanan metadata (berurutan)
          </div>
          <div style="background:#1e1e1e;color:#ddd;border-radius:6px;padding:10px;max-height:320px;overflow-y:auto;font-family:monospace;font-size:11px;line-height:1.4">
            <div v-for="(log, idx) in cycleLogs" :key="idx" v-html="log"></div>
          </div>
          <div class="mt-2 text-12">
            <span v-if="cycleStep === 'processing'">
              <VueFeather type="loader" animation="spin" size="12"></VueFeather>
              Sedang memproses... ({{cycleProgress.done}}/{{cycleProgress.total}})
            </span>
            <span v-else-if="cycleStep === 'done'" class="text-success text-bold">
              Selesai. Total berhasil: {{cycleProgress.done}} dari {{cycleProgress.total}}.
              <span v-if="cycleProgress.failed>0" class="text-danger">
                Gagal: {{cycleProgress.failed}}.
              </span>
            </span>
          </div>
          <div class="mt-3 mb-1 d-flex justify-content-center">
            <b-button v-if="cycleStep === 'done'" class="button button--primary" @click="()=>{$bvModal.hide('modal-siklus');resetCycleStep();}">Tutup</b-button>
            <b-button v-else class="button button--outlined" disabled>Memproses...</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal hide-header hide-footer id="modal-filter" modal-class="modal modal--primary" size="lg">
      <div class="modal__header">
        <div class="modal__header__title">
          <div class="modal__header__title__name">
            Filter Daftar Pelaporan
          </div>
          <div class="modal__header__title__description">
            Gunakan filter yang sesuai untuk mendapatkan hasil pencarian yang lebih baik
          </div>
        </div>
        <div class="modal__header__close">
          <button class="button button--action" @click="$bvModal.hide('modal-filter')">
            <VueFeather type="x" size="16" stroke-width="1"></VueFeather>
          </button>
        </div>
      </div>
      <div class="modal__body">
        <div class="form">
          <b-form-group label="Jenis Statistik">
            <b-form-radio-group
              v-model="filter.statisticType"
              :options="options.statisticType"
            ></b-form-radio-group>
          </b-form-group>

          <b-form-group label="Status">
            <Treeselect
              clearable placeholder="Pilih status"
              v-model="filter.status" :options="options.status" :disable-branch-nodes="true"
            />
          </b-form-group>
          <b-form-group label="Produsen Data">
            <Treeselect
              clearable
              valueFormat="object"
              placeholder="Nama Produsen Data"
              v-model="filter.produsenData"
              :async="true"
              :options="options.produsenData"
              :loadOptions="produsenDataLoadOptions"
              :normalizer="produsenDataNormalizer"
              searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
            />
          </b-form-group>
        </div>
      </div>
      <div class="modal__footer">
        <div class="modal__footer__action">
          <b-button class="button button--outlined mr-2" @click="()=>{
            filter.statisticType = null;
            filter.status = null;
            filter.produsenData = null;
            tagsFilter.statisticType = null;
            tagsFilter.status = null;
            tagsFilter.produsenData = null;
            $bvModal.hide('modal-filter');
            getSummaryMetadata();
          }">Reset</b-button>
          <b-button class="button button--outlined" @click="$bvModal.hide('modal-filter')">Batal</b-button>
          <b-button class="button button--primary" @click="()=>{$bvModal.hide('modal-filter');getSummaryMetadata()}">Terapkan</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal hide-header hide-footer size="sm" id="modal-loading" content-class="modal modal--error text-center p-2" centered dialog-class="d-flex justify-content-center">
      <div class="d-flex justify-content-start px-2 py-3">
        <img v-if="modal.isError" src="@/assets/img/error.gif" width="70" height="70" />
        <img v-else src="@/assets/img/loader.gif" width="70" height="70" />
        <div class="ml-2">
          <div :style="'font-weight:600;font-size:16px;color:'+ (modal.isError? '#d1093b':'#01ad85')" class="text-left">
            {{ modal.title }}
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;" class="text-left">
            {{ modal.content }}
          </div>
        </div>
      </div>
      <div class="modal__close" style="position: absolute;top: 0;right: 0;">
        <b-button v-on:click="()=>{$bvModal.hide('modal-loading');}">
          <VueFeather type="x" size="14"></VueFeather>
        </b-button>
      </div>
    </b-modal>
  </div>
  </template>
  <script>
  import "@/assets/scss/main.scss";
import Breadcrumbs from "@/components/Breadcrumbs";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import moment from "moment";
import swal from "sweetalert2";
import VueFeather from 'vue-feather';
import MsService from "../../../services/MsService";
import SdsService from "../../../services/SdsService";
import store from "../../../store";
import * as role from "../SdiRole";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import XLSX from "xlsx";
import PDFMerger from "pdf-merger-js/browser";
  export default {
    components: {
      VueFeather,
      Breadcrumbs,
      Treeselect
    },
    data: () => {
      return {
        breadcrumbs:[
           {
              text:'Beranda',
              href:'/',
           },
           {
              text:'Daftar Usulan MS-Keg',
              href:'',
              active:true,
           }
        ],
        isMounted:false,
        user:null,
        userRoles:[],
        currentPageMetadataStatistikKegiatan: 1,
        rowsMetadataStatistikKegiatan: 0,
        goto:0,
        perPage: 10,
        id: 0,
        dataMetadataStatistikKegiatan: [],
        filter:{
          name:null,
          statistic_type:null,
          status:null,
          requester:null,
          approver:null,
          produsenData:null,
          walidata:null,
        },
        tagsFilter:{
          name:null,
          submissionType:null,
          sdsTypes:null,
          subjectField:null,
          status:null,
          requester:null,
          approver:null,
          produsenData:null,
          walidata:null,
        },
        fieldsMetadata: [
          {
            key: "no",
            label: "No.",
            tdClass: "text-center",
          },
          {
            key: "name",
            label: "Nama Kegiatan",
            thClass: "text-left",
            thStyle: { minWidth: "90%" }
          },
          {
            key: "tahun",
            label: "Tahun",
            thClass: "text-left",
            thStyle: { minWidth: "90%" }
          },
          {
            key: "statistic_type",
            label: "Jenis Statistik",
            thClass: 'text-left',
            tdClass: "text-left",
            thStyle: { minWidth: "130px" }
          },
          
          {
            key: "produsen_data_name",
            label: "Produsen Data",
            class: 'text-left w-170 w-max-200 text-wrap',
          },
          {
            key: "created_at",
            label: "Tanggal Dibuat",
            thClass: 'text-left',
            tdClass: "text-left"
          },
          {
            key: "created_by",
            label: "Pelapor",
            thClass: 'text-left',
            tdClass: "text-left"
          },
          {
            key: "status",
            label: "Status",
            class: "text-center text-nowrap"
          },
          {
            key: "aksi",
            label: "Aksi",
            thStyle: { minWidth: "100px" },
            tdClass: "text-center"
          },
        ],
        deletedId:null,
        siklusId:null,
        siklusItem:null,
        cycleStep: 'confirm', // 'confirm' | 'processing' | 'done'
        cycleLogs: [],
        cycleProgress: { done: 0, total: 0, failed: 0 },
        requesters: 0,
        isLoading: true,
        divisi: null,
        idMetadataKegiatan: null,
        submissionPeriod:null,
        options:{
          submissionPeriod:[],
          statisticType:[
            { value: 'STATISTIK_DASAR', text: 'Statistik Dasar' },
            { value: 'STATISTIK_SEKTORAL', text: 'Statistik Sektoral' },
            { value: 'STATISTIK_KHUSUS', text: 'Statistik Khusus' }
          ],
          status:[
            { id: 'DRAFT', label: 'Draft' },
            { id: 'SUBMITTED', label: 'Submit' },
            { id: 'UNDER_REVIEW', label: 'Sedang Diperiksa' },
            { id: 'APPROVED', label: 'Disetujui' },
            { id: 'REJECTED', label: 'Ditolak' },
            { id: 'CORRECTION_REQUIRED', label: 'Perlu Perbaikan' },
            { id: 'REVISED', label: 'Sudah Diperbaiki' }
          ],
          produsenData:[]
        },
        modal:{
          isError:false,
          title:"",
          content:""
        },
        exportedKeg: null,
        exportedVars: [],
        exportedInds: [],
        data: null,
        msKeg: null,
        form_metadata:{
        base_id:null,
        submission_period: new Date().getFullYear(),
        data: null,
        reviews: null,
        status: "DRAFT",
        rejection_note: null,
        submitter: null,
        produsen_data:null,
        walidata_pusat: null,
        version: 'v2',
        changes: null,
          current_role:"hahaha"
      },
      };
    },
    async mounted() {
      let roles = this.$store.getters['auth/user'].role.slice(1,-1).split(", ").sort();
      this.current_role = localStorage.getItem('msCurrentRole') === null ? roles[0] : localStorage.getItem('msCurrentRole');
      this.getUserInfo(store.getters["auth/user"])
      this.setSubmissionPeriod();
      this.getSummaryMetadata();
      this.isMounted = true;
    },
    computed:{
      filterCount(){
        let count = 0;
        if(this.tagsFilter.name){ count += 1; }
        if(this.tagsFilter.statisticType){ count += 1; }
        if(this.tagsFilter.status){ count += 1; }
        if(this.tagsFilter.produsenData){ count += 1; }
        return count;
      },
    },
    watch:{
      siklusId(val){
        this.getDetailMsKeg(val)
      },
      goto(){
        if(this.goto>0){
          if(this.currentPageMetadataStatistikKegiatan != this.goto){
            this.getSummaryMetadata();
          }
          this.currentPageMetadataStatistikKegiatan = this.goto;
        }else{
          this.dataMetadataStatistikKegiatan = []
          this.rowsMetadataStatistikKegiatan = 0;
        }
      },
      currentPageMetadataStatistikKegiatan(){
        if(this.currentPageMetadataStatistikKegiatan != this.goto){
          this.getSummaryMetadata();
        }
      },
      
    },
    methods: {
      resetCycleStep(){
        this.cycleStep = 'confirm';
        this.cycleLogs = [];
        this.cycleProgress = { done: 0, total: 0, failed: 0 };
      },
      appendCycleLog(text, level = 'info'){
        const colors = {
          info: '#9cdcfe',
          success: '#4ec9b0',
          error: '#f48771',
          warn: '#dcdcaa',
          step: '#569cd6'
        };
        const ts = new Date().toLocaleTimeString();
        const safe = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        this.cycleLogs.push(`<span style="color:#888">[${ts}]</span> <span style="color:${colors[level] || colors.info}">${safe}</span>`);
      },
      createNewCycle(){
        this.isLoading=true;
        this.cycleStep = 'processing';
        this.cycleLogs = [];
        this.cycleProgress = { done: 0, total: 0, failed: 0 };
        const totalItems = (this.siklusItem.ms_var?.length || 0) + (this.siklusItem.ms_ind?.length || 0);
        this.cycleProgress.total = 1 + totalItems; // 1 untuk mskeg
        this.appendCycleLog(`Memulai proses tambah siklus baru...`, 'step');
        this.appendCycleLog(`Total metadata: ${this.siklusItem.ms_var?.length || 0} variabel, ${this.siklusItem.ms_ind?.length || 0} indikator`, 'info');
        const date = new Date();
        let data = this.siklusItem.data
        if(this.siklusItem.version == 'v1'){
              let keg = this.siklusItem.data;
              data = {
                judul_kegiatan:        keg.judulKegiatan,
                tahun:                 keg.tahun,
                jenis_statistik:       this.siklusItem.statistic_type,
                cara_pengumpulan_data: keg.caraPengumpulanData,
                sektor_kegiatan:       keg.sektorKegiatan,
                identitas_rekomendasi: null,
                blok_i: {
                  instansi_penyelanggara: keg.blokI.instansiPenyelanggara,
                  alamat_instansi_penyelenggara: {
                    alamat:    keg.blokI.alamatLengkapInstansiPenyelenggara,
                    telepon:   keg.blokI.telepon,
                    email:     keg.blokI.email,
                    faksimile: keg.blokI.faksimile
                  }
                },
                blok_ii: {
                  unit_penanggung_jawab: {
                    eselon1: keg.blokII.unitPenanggungJawabEselon1,
                    eselon2: keg.blokII.unitPenanggungJawabEselon2
                  },
                  penanggung_jawab_teknis: {
                    nama:      keg.blokII.namaPenanggungJawabTeknis,
                    jabatan:   keg.blokII.jabatanPenanggungJawabTeknis,
                    alamat:    keg.blokII.alamatPenanggungJawabTeknis,
                    telepon:   keg.blokII.teleponPenanggungJawabTeknis,
                    email:     keg.blokII.emailPenanggungJawabTeknis,
                    faksimile: keg.blokII.faksimilePenanggungJawabTeknis
                  }
                },
                blok_iii: {
                  latar_belakang_kegiatan: keg.blokIII.latarBelakangKegiatan,
                  tujuan_kegiatan:         keg.blokIII.tujuanKegiatan,
                  rencana_jadwal_kegiatan: {
                    perencanaan_kegiatan: keg.blokIII.rencanaJadwalKegiatan.perencanaanKegiatan.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                    desain:               keg.blokIII.rencanaJadwalKegiatan.desain.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                    pengumpulan_data:     keg.blokIII.rencanaJadwalKegiatan.pengumpulanData.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                    pengolahan_data:      keg.blokIII.rencanaJadwalKegiatan.pengolahanData.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                    analisis:             keg.blokIII.rencanaJadwalKegiatan.analisis.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                    diseminasi_hasil:     keg.blokIII.rencanaJadwalKegiatan.diseminasiHasil.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                    evaluasi:             keg.blokIII.rencanaJadwalKegiatan.evaluasi.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')}))
                  },
                  variabel_yang_dikumpulkan: keg.blokIII.variabelYangDikumpulkan.map(x=>({
                    nama: x.nama,
                    konsep: x.konsep,
                    definisi: x.definisi,
                    referensi_waktu: x.referensiWaktu
                  }))
                },
                blok_iv: {
                  kegiatan_ini_dilakukan:                    keg.blokIV.kegiatanIniDilakukan,
                  frekuensi_penyelanggara:                   keg.blokIV.frekuensiPenyelanggara,
                  tipe_pengumpulan_data:                     keg.blokIV.tipePengumpulanData,
                  cakupan_wilayah_pengumpulan_data:          keg.blokIV.cakupanWilayahPengumpulanData,
                  sebagian_cakupan_wilayah_pengumpulan_data: keg.blokIV.cakupanWilayahPengumpulanData == 'SEBAGIAN_WILAYAH_INDONESIA' && keg.blokIV.sebagianCakupanWilayahPengumpulanData && keg.blokIV.sebagianCakupanWilayahPengumpulanData.length>0?  
                    keg.blokIV.sebagianCakupanWilayahPengumpulanData.map(x=>({
                      kode_provinsi: null,
                      nama_provinsi: x.provinsi,
                      kode_kabupaten_kota: null,
                      nama_kabupaten_kota: x.kabupatenKota
                    })) : [],
                  metode_pengumpulan_data: {
                    wawancara:                  keg.blokIV.metodePengumpulanData.wawancara,
                    mengisi_kuesioner_sendiri:  keg.blokIV.metodePengumpulanData.mengisiKuesionerSendiri,
                    pengamatan:                 keg.blokIV.metodePengumpulanData.pengamatan,
                    pengumpulan_data_sekunder:  keg.blokIV.metodePengumpulanData.pengumpulanDataSekunder,
                    lainnya:                    keg.blokIV.metodePengumpulanData.lainnya,
                    metode_pengumpulan_lainnya: keg.blokIV.metodePengumpulanData.metodePengumpulanLainnya ? keg.blokIV.metodePengumpulanData.metodePengumpulanLainnya : null
                  },
                  sarana_pengumpulan_data: {
                    papi: keg.blokIV.saranaPengumpulanData.papi,
                    capi: keg.blokIV.saranaPengumpulanData.capi,
                    cati: keg.blokIV.saranaPengumpulanData.cati,
                    cawi: keg.blokIV.saranaPengumpulanData.cawi,
                    mail: keg.blokIV.saranaPengumpulanData.mail,
                    lainnya: keg.blokIV.saranaPengumpulanData.lainnya,
                    sarana_pengumpulan_lainnya: 
                      keg.blokIV.saranaPengumpulanData.saranaPengumpulanLainnya ? keg.blokIV.saranaPengumpulanData.saranaPengumpulanLainnya : null, 
                  },
                  unit_pengumpulan_data: {
                    individu:                      keg.blokIV.unitPengumpulanData.individu,
                    rumah_tangga:                  keg.blokIV.unitPengumpulanData.rumahTangga,
                    usaha_atau_perusahaan:         keg.blokIV.unitPengumpulanData.usahaAtauPerusahaan,
                    lainnya:                       keg.blokIV.unitPengumpulanData.lainnya,
                    unit_pengumpulan_data_lainnya: keg.blokIV.unitPengumpulanData.unitPengumpulanDataLainnya ? keg.blokIV.unitPengumpulanData.unitPengumpulanDataLainnya : null
                  }
                },
                blok_v: {
                  jenis_rancangan_sampel:                        keg.blokV.jenisRancanganSampel,
                  metode_pemilihan_sampel_tahap_terakhir:        keg.blokV.metodePemilihanSampelTahapTerakhir,
                  metode_yang_digunakan:                         keg.blokV.metodeYangdigunakan == 'MULTI_STAGE_SAMPLING' ? 'PROBABILTY_PROPORTIONAL_TO_SIZE_SAMPLING' : keg.blokV.metodeYangdigunakan,
                  kerangka_sampel_tahap_terakhir:                keg.blokV.kerangkaSampelTahapTerakhir,
                  fraksi_sampel_keseluruhan:                     keg.blokV.fraksiSampelKeseluruhan,
                  nilai_perkiraan_sampling_error_variabel_utama: keg.blokV.nilaiPerkiraanSamplingErrorVariabelUtama,
                  unit_sampel:                                   keg.blokV.unitSampel,
                  unit_observasi:                                keg.blokV.unitObservasi
                },
                blok_vi: {
                  apakah_melakukan_uji_coba: keg.blokVI.apakahMelakukanUjiCoba,
                  metode_pemeriksaan_kualitas_pengumpulan_data: {
                    kunjungan_kembali: keg.blokVI.metodePemeriksaanKualitasPengumpulanData.kunjunganKembali,
                    supervisi:         keg.blokVI.metodePemeriksaanKualitasPengumpulanData.supervisi,
                    taskforce:         keg.blokVI.metodePemeriksaanKualitasPengumpulanData.taskforce,
                    lainnya:           keg.blokVI.metodePemeriksaanKualitasPengumpulanData.lainnya,
                    metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: 
                      keg.blokVI.metodePemeriksaanKualitasPengumpulanData.metodePemeriksaanKualitasPengumpulanDataLainnya ? keg.blokVI.metodePemeriksaanKualitasPengumpulanData.metodePemeriksaanKualitasPengumpulanDataLainnya : null
                  },
                  apakah_melakukan_penyesuaian_nonrespon:                   keg.blokVI.apakahMelakukanPenyesuaianNonrespon,
                  petugas_pengumpulan_data:                                 keg.blokVI.petugasPengumpulanData,
                  persyaratan_pendidikan_terendah_petugas_pengumpulan_data: keg.blokVI.persyaratanPendidikanTerendahPetugasPengumpulanData,
                  jumlah_petugas_supervisor:                                keg.blokVI.jumlahPetugasSupervisor,
                  jumlah_petugas_enumerator:                                keg.blokVI.jumlahPetugasEnumerator,
                  apakah_melakukan_pelatihan_petugas:                       keg.blokVI.apakahMelakukanPelatihanPetugas
                },
                blok_vii: {
                  tahapan_pengolahan_data: {
                    editing:    keg.blokVII.tahapanPengolahanData.udi,
                    coding:     keg.blokVII.tahapanPengolahanData.udi,
                    data_entry: keg.blokVII.tahapanPengolahanData.udi,
                    validasi:   keg.blokVII.tahapanPengolahanData.udi
                  },
                  metode_analisis: keg.blokVII.metodeAnalisis,
                  unit_analsis: {
                    individu:              keg.blokVII.unitAnalsis.individu,
                    rumah_tangga:          keg.blokVII.unitAnalsis.rumahTangga,
                    usaha_atau_perusahaan: keg.blokVII.unitAnalsis.usahaAtauPerusahaan,
                    lainnya:               keg.blokVII.unitAnalsis.lainnya,
                    unit_analisis_lainnya: keg.blokVII.unitAnalsis.unitAnalisisLainnya ? keg.blokVII.unitAnalsis.unitAnalisisLainnya : null
                  },
                  tingkat_penyajian_hasil_analisis: {
                    nasional:            keg.blokVII.tingkatPenyajianHasilAnalisis.nasional,
                    provinsi:            keg.blokVII.tingkatPenyajianHasilAnalisis.provinsi,
                    kabupaten_atau_kota: keg.blokVII.tingkatPenyajianHasilAnalisis.kabupatenAtauKota,
                    kecamatan:           keg.blokVII.tingkatPenyajianHasilAnalisis.kecamatan,
                    lainnya:             keg.blokVII.tingkatPenyajianHasilAnalisis.lainnya,
                    tingkat_penyajian_hasil_analisis_lainnya: keg.blokVII.tingkatPenyajianHasilAnalisis.tingkatPenyajianHasilAnalisisLainnya ? keg.blokVII.tingkatPenyajianHasilAnalisis.tingkatPenyajianHasilAnalisisLainnya : null, 
                  }
                },
                blok_viii: {
                  ketersediaan_produk_tercetak: keg.blokVIII.ketersediaanProdukTercetak,
                  ketersediaan_produk_digital: keg.blokVIII.ketersediaanProdukDigital,
                  ketersediaan_produk_mikrodata: keg.blokVIII.ketersediaanProdukMikrodata,
                  rencana_jadwal_rilis_produk_tercetak: keg.blokVIII.ketersediaanProdukTercetak ? keg.blokVIII.rencanaJadwalRilisProdukTercetak.map(x=>moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
                  rencana_jadwal_rilis_produk_digital: keg.blokVIII.ketersediaanProdukDigital ? keg.blokVIII.rencanaJadwalRilisProdukDigital.map(x=>moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
                  rencana_jadwal_rilis_produk_mikrodata: keg.blokVIII.ketersediaanProdukMikrodata ? keg.blokVIII.rencanaJadwalRilisProdukMikrodata.map(x=>moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
                }
              };         
            }
        this.form = {
                base_id: this.siklusItem.id,
                submission_period: date.getFullYear(),
                data: data,
                reviews: null,
                status: "DRAFT",
                rejection_note: null,
                submitter: this.user,
                produsen_data: {
                  id: this.siklusItem.produsen_data_id,
                  name: this.siklusItem.produsen_data_name,
                  province_code: this.siklusItem.produsen_data_province_code,
                  city_code: this.siklusItem.produsen_data_city_code
                },
                walidata_pusat: {
                  id: this.siklusItem.walidata_pusat_id,
                  name: this.siklusItem.walidata_pusat_name
                },
                version: 'v2',
                changes: null,
            };
            this.sendMetadataKegiatan()
      },
      async sendMetadataKegiatan(){
        try {
          this.appendCycleLog(`Mengirim MS-Keg ke server...`, 'step');
          const result = await MsService.saveNewMsKeg(this.form);
          const mskeg_id = result.data.result[0].id;
          this.appendCycleLog(`✓ MS-Keg tersimpan (id=${mskeg_id})`, 'success');
          this.cycleProgress.done += 1;
          await this.$nextTick();
          const msVars = this.siklusItem.ms_var || [];
          const date = new Date();
          this.appendCycleLog(`--- Mulai proses ${msVars.length} metadata variabel ---`, 'step');
          await this.$nextTick();
          for (let i = 0; i < msVars.length; i++) {
            const msvarItem = msVars[i];
            const data = this.normalizeMsVarData(msvarItem);
            const form = this.buildMsVarForm(mskeg_id, data, date);
            try {
              this.appendCycleLog(`[${i+1}/${msVars.length}] Mengirim MS-Var "${data?.nama || '-'}"`, 'step');
              await this.$nextTick();
              const res = await this.sendMetadataVariabel(form);
              console.log(`[${i+1}/${msVars.length}] MS-Var tersimpan:`, res);
              this.appendCycleLog(`  ✓ MS-Var ${i+1} SUKSES`, 'success');
              this.cycleProgress.done += 1;
            } catch (err) {
              console.error(`[${i+1}/${msVars.length}] MS-Var gagal:`, err);
              this.appendCycleLog(`  ✗ MS-Var ${i+1} GAGAL: ${err?.response?.status || ''} ${err?.response?.data?.message || err?.message || err}`, 'error');
              this.cycleProgress.failed += 1;
            }
            await this.$nextTick();
          }
          const msInds = this.siklusItem.ms_ind || [];
          this.appendCycleLog(`--- Mulai proses ${msInds.length} metadata indikator ---`, 'step');
          await this.$nextTick();
          for (let i = 0; i < msInds.length; i++) {
            const msindItem = msInds[i];
            const data = this.normalizeMsIndData(msindItem);
            const form = this.buildMsIndForm(mskeg_id, data, date);
            try {
              this.appendCycleLog(`[${i+1}/${msInds.length}] Mengirim MS-Ind "${data?.nama || '-'}"`, 'step');
              await this.$nextTick();
              const res = await this.sendMetadataIndikator(form);
              console.log(`[${i+1}/${msInds.length}] MS-Ind tersimpan:`, res);
              this.appendCycleLog(`  ✓ MS-Ind ${i+1} SUKSES`, 'success');
              this.cycleProgress.done += 1;
            } catch (err) {
              console.error(`[${i+1}/${msInds.length}] MS-Ind gagal:`, err);
              this.appendCycleLog(`  ✗ MS-Ind ${i+1} GAGAL: ${err?.response?.status || ''} ${err?.response?.data?.message || err?.message || err}`, 'error');
              this.cycleProgress.failed += 1;
            }
            await this.$nextTick();
          }
          this.appendCycleLog(`=== Selesai. Berhasil: ${this.cycleProgress.done}, Gagal: ${this.cycleProgress.failed} ===`, this.cycleProgress.failed > 0 ? 'warn' : 'success');
          this.cycleStep = 'done';
          this.isLoading = false;
          this.getSummaryMetadata();
        } catch (error) {
          this.appendCycleLog(`✗ Gagal menyimpan MS-Keg: ${error?.response?.status || ''} ${error?.message || error}`, 'error');
          console.error('[sendMetadataKegiatan] error:', error);
          this.cycleProgress.failed += 1;
          this.cycleStep = 'done';
          this.isLoading = false;
          this.getSummaryMetadata();
        }
      },
      normalizeMsVarData(msvarItem){
        let data = msvarItem.data;
        if(msvarItem.version == 'v1'){
          let variable = msvarItem.data;
          data = {
            nama: variable.nama,
            alias: variable.alias,
            konsep: variable.konsep ? [variable.konsep] : [null],
            definisi: variable.definisi,
            referensi_pemilihan: variable.referensiPemilihan && variable.referensiPemilihan.length>0 ? variable.referensiPemilihan.map(x=>x.nama) : [],
            referensi_waktu: variable.referensiWaktu,
            ukuran: variable.ukuran,
            satuan: variable.satuan,
            tipe_data: variable.tipeData,
            value_domain: variable.valueDomain && variable.valueDomain.length>0 ? variable.valueDomain : [],
            aturan_validasi: variable.aturanValidasi && variable.aturanValidasi.length >0 ? variable.aturanValidasi : [null],
            kalimat_pertanyaan: variable.kalimatPertanyaan,
            apakah_variabel_bisa_diakses_umum: variable.apakahVariabelBisaDiaksesUmum,
            id_sds: null,
          };
        }
        if(data.value_domain == null || data.value_domain === undefined){
          data.value_domain = [];
        }
        return data;
      },
      buildMsVarForm(mskeg_id, data, date){
        return {
          ms_keg_id: mskeg_id,
          submission_period: date.getFullYear(),
          data: data,
          reviews: null,
          status: "DRAFT",
          rejection_note: null,
          submitter: this.user,
          produsen_data: {
            id: this.siklusItem.produsen_data_id,
            name: this.siklusItem.produsen_data_name,
            province_code: this.siklusItem.produsen_data_province_code,
            city_code: this.siklusItem.produsen_data_city_code
          },
          walidata_pusat: {
            id: this.siklusItem.walidata_pusat_id,
            name: this.siklusItem.walidata_pusat_name
          },
          version: 'v2',
          changes: null,
        };
      },
      normalizeMsIndData(msindItem){
        let data = msindItem.data;
        if(msindItem.version == 'v1'){
          let indikator = msindItem.data;
          data = {
            nama: indikator.nama,
            konsep: indikator.konsep ? [indikator.konsep] : [null],
            definisi: indikator.definisi,
            interpretasi: indikator.interpretasi,
            metode_perhitungan: indikator.metodeAtauRumusPerhitungan,
            rumus: null,
            ukuran: indikator.ukuran,
            satuan: indikator.satuan,
            variabel_disaggregasi: indikator.variabelDisaggregasi && indikator.variabelDisaggregasi.length>0 ? indikator.variabelDisaggregasi : [{nama: null, sumber:'input-manual'}],
            apakah_indikator_komposit: indikator.apakahIndikatorKomposit,
            indikator_pembangun: indikator.indikatorPembangun && indikator.indikatorPembangun.length>0 ? indikator.indikatorPembangun.map(x=>({
                nama: x.nama,
                sumber_publikasi: x.ketersediaanPublikasi.map(x=>x.nama)
              })
            ):[],
            variabel_pembangun: indikator.variabelPembangun && indikator.variabelPembangun.length>0 ? indikator.variabelPembangun.map(x=>({
                nama: x.nama,
                kegiatan_penghasil: x.kegiatanPenghasil
              })
            ):[],
            level_estimasi: indikator.levelEstimasi,
            apakah_indikator_bisa_diakses_umum: indikator.apakahIndikatorBisaDiaksesUmum,
            id_sds: null
          };
          //change structure was caused disagregation can be subset of sds
          data.variabel_disaggregasi = data.variabel_disaggregasi.map(x=>{
            if(typeof x == 'string' || x == null){
              return data.id_sds ? {nama: x, sumber:'sds'} : {nama: x, sumber:'input-manual'}
            }else{
              return x
            }
          });
        }
        return data;
      },
      buildMsIndForm(mskeg_id, data, date){
        return {
          ms_keg_id: mskeg_id,
          submission_period: date.getFullYear(),
          data: data,
          reviews: null,
          status: "DRAFT",
          rejection_note: null,
          submitter: this.user,
          produsen_data: {
            id: this.siklusItem.produsen_data_id,
            name: this.siklusItem.produsen_data_name,
            province_code: this.siklusItem.produsen_data_province_code,
            city_code: this.siklusItem.produsen_data_city_code
          },
          walidata_pusat: {
            id: this.siklusItem.walidata_pusat_id,
            name: this.siklusItem.walidata_pusat_name
          },
          version: 'v2',
          changes: null,
        };
      },
      _legacyOldSendMetadataKegiatan(){
        // legacy block intentionally inert - superseded by sendMetadataKegiatan above
      },
      async sendMetadataVariabel(data){
        return MsService.saveNewMsVar(data);
      },
      async sendMetadataIndikator(data){
        return MsService.saveNewMsInd(data);
      },
      async getDetailMsKeg(id){
        await MsService.getMsKegById(id).then(
          response => { 
            this.siklusItem = response.data.result[0]
          },
          error => {
            console.error(error);
          }
        );
      },
      getUserInfo(user){
        this.user = {
          username: user.username,
          name : user.name,
          email: user.email,
          organization: {
            id: user.sdiOrganization.id,
            name: user.sdiOrganization.name,
            address: user.sdiOrganization.details.address,
            province: user.sdiOrganization.details.province,
            city: user.sdiOrganization.details.city,
          } 
        }
        this.userRoles = user.role.slice(1,-1).split(", ");
      },
      setSubmissionPeriod(){
        let currentYear = new Date().getFullYear();
        this.submissionPeriod = currentYear;
        this.options.submissionPeriod = this.range(2021, currentYear)
          
      },
      range(start, stop, step = 1){
        return Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
      },
      async getSummaryMetadata() {
        localStorage.setItem('msSummarySubmissionPeriod',  this.submissionPeriod);
        this.isLoading = true;
        // Reset tags filter
        this.tagsFilter.name = null;
        this.tagsFilter.statisticType = null;
        this.tagsFilter.status = null;
        this.tagsFilter.produsenData = null;

        let page = this.currentPageMetadataStatistikKegiatan-1;
        let filter = "submissionPeriod="+this.submissionPeriod +"&page="+page;

        // Apply search/filter from this.filter
        if(this.filter.name){
          filter += "&name="+encodeURIComponent(this.filter.name);
          this.tagsFilter.name = this.filter.name;
        }
        if(this.filter.statisticType){
          filter += "&statisticType="+this.filter.statisticType;
          this.tagsFilter.statisticType = this.filter.statisticType;
        }
        if(this.filter.status){
          filter += "&status="+this.filter.status;
          this.tagsFilter.status = this.filter.status;
        }
        if(this.filter.produsenData){
          filter += "&produsenDataId="+this.filter.produsenData.id;
          this.tagsFilter.produsenData = this.filter.produsenData;
        }

        if(role.isWalidata([this.current_role])){
          if(role.isWalidataPusat(this.current_role)){
            filter += "&requesterOrganizationId="+this.user.organization.id;
          }else{
            filter += "&produsenDataProvinceCode="+this.user.organization.province.code;
            filter += "&produsenDataCityCode="+this.user.organization.city.code;
          }
        }
        if(role.isProdusenData([this.current_role])){
          if(this.user.organization.id){
            filter += "&produsenDataId="+this.user.organization.id;
          }else{
            filter += "&produsenDataName="+this.user.organization.name
          }
        }

        this.dataMetadataStatistikKegiatan = [];
        await MsService.getMsKegList(filter).then(
          response => {
            this.dataMetadataStatistikKegiatan = response.data.result[0].content;
            this.rowsMetadataStatistikKegiatan = response.data.result[0].total_elements;
            this.isLoading = false;
          },
          error => {
            console.log(error);
            this.isLoading = false;
          }
        );
        this.goto = this.currentPageMetadataStatistikKegiatan;
      },
      produsenDataNormalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
      async produsenDataLoadOptions({searchQuery, callback}){
        let name = searchQuery;
        let page = 0;
        let provinceCode = null;
        let cityCode = null;

        if(role.isWalidata([this.current_role])){
          if(!role.isWalidataPusat(this.current_role)){
            provinceCode = this.user.organization.province ? this.user.organization.province.code : null;
            cityCode = this.user.organization.city ? this.user.organization.city.code : null;
          }
        }

        await SdsService.getProdusenData(page, name, provinceCode, cityCode).then(
          (result)=>{
            let options = result.data.content;
            callback(null, options);
          },
          (error)=>{
            console.log(error);
            callback(null, []);
          }
        );
      },
      showModalFilter(){
        // Ensure current filter values reflect tagsFilter (in case state drifted)
        if(this.tagsFilter.statisticType == null){ this.filter.statisticType = null; }
        if(this.tagsFilter.status == null){ this.filter.status = null; }
        if(this.tagsFilter.produsenData == null){ this.filter.produsenData = null; }
        this.$bvModal.show('modal-filter');
      },
      resetFilter(){
        this.filter = {
          name: null,
          statisticType: null,
          status: null,
          requester: null,
          approver: null,
          produsenData: null,
          walidata: null,
        };
        this.tagsFilter = {
          name: null,
          statisticType: null,
          status: null,
          requester: null,
          approver: null,
          produsenData: null,
          walidata: null,
        };
        this.options.produsenData = [];
        this.getSummaryMetadata();
      },
      async download(msKeg, type) {
        try {
          this.$bvModal.show('modal-loading');
          this.modal.isError = false;
          this.modal.title = "Mohon tunggu sebentar";
          this.modal.content = "Proses mengambil detil kegiatan dan export sedang dilakukan";

          this.exportedKeg = null;
          this.exportedVars = [];
          this.exportedInds = [];
          this.data = null;
          this.msKeg = null;

          const detailResp = await MsService.getMsKegById(msKeg.id);
          this.exportedKeg = detailResp.data.result[0];

          if (!this.exportedKeg || !this.exportedKeg.data) {
            throw new Error("Data kegiatan tidak ditemukan");
          }
          this.data = this.exportedKeg.data;
          this.msKeg = this.exportedKeg;

          // Safety check untuk ms_var
          this.exportedVars = (this.exportedKeg.ms_var || []).map(x => {
            if(x.version == 'v1'){
              x.data = this.updateMsVarV1Structure(x.data);
            }
            return x.data;
          });

          // Safety check untuk ms_ind
          this.exportedInds = (this.exportedKeg.ms_ind || []).map(x => {
            if(x.version == 'v1'){
              x.data = this.updateMsIndV1Structure(x.data);
            }
            return x.data;
          });

          await this.$nextTick();

          if (type == "excel") {
            this.downloadExcel();
          } else {
            await this.downloadPdf();
          }

          this.$bvModal.hide('modal-loading');
        } catch (error) {
          this.modal.isError = true;
          this.modal.title = "Error Server";
          this.modal.content = "Terjadi error pada aplikasi: " + (error.message || "Unknown error") + ". Silahkan hubungi admin.";
          console.log(error);
        }
      },
      downloadExcel(){
        // Bangun workbook dari data JSON hasil API
        const workbook = XLSX.utils.book_new();

        // Sheet 1: Metadata Kegiatan (flat key-value)
        const kegRows = this.buildKegRowsForExcel(this.data || {});
        const kegWorksheet = XLSX.utils.json_to_sheet(kegRows);
        XLSX.utils.book_append_sheet(workbook, kegWorksheet, "Metadata Kegiatan");

        // Sheet 2: Metadata Variabel
        const varRows = (this.exportedVars || []).map(v => ({
          nama: v.nama || '-',
          alias: v.alias || '-',
          konsep: Array.isArray(v.konsep) ? v.konsep.join('; ') : (v.konsep || '-'),
          definisi: v.definisi || '-',
          referensi_pemilihan: Array.isArray(v.referensi_pemilihan) ? v.referensi_pemilihan.join('; ') : (v.referensi_pemilihan || '-'),
          referensi_waktu: v.referensi_waktu || '-',
          ukuran: v.ukuran || '-',
          satuan: v.satuan || '-',
          tipe_data: v.tipe_data || '-',
          value_domain: Array.isArray(v.value_domain) ? v.value_domain.join('; ') : (v.value_domain || '-'),
          apakah_variabel_bisa_diakses_umum: v.apakah_variabel_bisa_diakses_umum || '-'
        }));
        const varWorksheet = XLSX.utils.json_to_sheet(varRows);
        XLSX.utils.book_append_sheet(workbook, varWorksheet, "Metadata Variabel");

        // Sheet 3: Metadata Indikator
        const indRows = (this.exportedInds || []).map(i => ({
          nama: i.nama || '-',
          konsep: Array.isArray(i.konsep) ? i.konsep.join('; ') : (i.konsep || '-'),
          definisi: i.definisi || '-',
          interpretasi: i.interpretasi || '-',
          metode_perhitungan: i.metode_perhitungan || '-',
          ukuran: i.ukuran || '-',
          satuan: i.satuan || '-',
          level_estimasi: i.level_estimasi || '-',
          apakah_indikator_komposit: i.apakah_indikator_komposit || '-',
          apakah_indikator_bisa_diakses_umum: i.apakah_indikator_bisa_diakses_umum || '-'
        }));
        const indWorksheet = XLSX.utils.json_to_sheet(indRows);
        XLSX.utils.book_append_sheet(workbook, indWorksheet, "Metadata Indikator");

        const createdDate = moment(new Date()).format("DD_MM_YYYY");
        const fileName = "export_ms_" + createdDate + ".xlsx";
        XLSX.writeFile(workbook, fileName, { bookSST: true, type: "base64" });
      },
      buildKegRowsForExcel(keg){
        // Flatten key fields untuk 1 kolom informasi (ringkas)
        const safe = (v) => (v === null || v === undefined || v === '') ? '-' : v;
        const b1 = keg.blok_i || {};
        const b1Alamat = b1.alamat_instansi_penyelenggara || {};
        const b2 = keg.blok_ii || {};
        const rows = [
          { Field: 'Judul Kegiatan', Value: safe(keg.judul_kegiatan) },
          { Field: 'Tahun', Value: safe(keg.tahun) },
          { Field: 'Jenis Statistik', Value: safe(keg.jenis_statistik) },
          { Field: 'Cara Pengumpulan Data', Value: safe(keg.cara_pengumpulan_data) },
          { Field: 'Sektor Kegiatan', Value: safe(keg.sektor_kegiatan) },
          { Field: 'Instansi Penyelenggara', Value: safe(b1.instansi_penyelanggara) },
          { Field: 'Alamat Instansi', Value: safe(b1Alamat.alamat) },
          { Field: 'Telepon', Value: safe(b1Alamat.telepon) },
          { Field: 'Email', Value: safe(b1Alamat.email) },
          { Field: 'Faksimile', Value: safe(b1Alamat.faksimile) },
          { Field: 'Unit Penanggung Jawab Eselon 1', Value: safe((b2.unit_penanggung_jawab || {}).eselon1) },
          { Field: 'Unit Penanggung Jawab Eselon 2', Value: safe((b2.unit_penanggung_jawab || {}).eselon2) },
          { Field: 'Nama Penanggung Jawab Teknis', Value: safe((b2.penanggung_jawab_teknis || {}).nama) },
          { Field: 'Jabatan Penanggung Jawab Teknis', Value: safe((b2.penanggung_jawab_teknis || {}).jabatan) },
        ];
        return rows;
      },
      async downloadPdf(){
        try {
          // Set vfs (font) - wajib dipanggil sebelum createPdf
          pdfMake.vfs = (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs)
            ? pdfFonts.pdfMake.vfs
            : pdfFonts;

          // Render setiap bagian ke blob
          const blobKeg = await new Promise((resolve) => {
            pdfMake.createPdf(this.buildSummaryKegDoc()).getBlob((b) => resolve(b));
          });
          const blobVar = await new Promise((resolve) => {
            pdfMake.createPdf(this.buildSummaryVarDoc()).getBlob((b) => resolve(b));
          });
          const blobInd = await new Promise((resolve) => {
            pdfMake.createPdf(this.buildSummaryIndDoc()).getBlob((b) => resolve(b));
          });

          // Gabungkan 3 PDF menggunakan pdf-merger-js agar orientasi per-halaman terjaga
          const merger = new PDFMerger();
          await merger.add(blobKeg);
          await merger.add(blobVar);
          await merger.add(blobInd);

          const createdDate = moment(new Date()).format("DD_MM_YYYY");
          const fileName = "export_ms_" + createdDate + ".pdf";
          await merger.save(fileName);
        } catch (error) {
          console.log(error)
          throw error;
        }
      },
      // -- Helper styles reused by all 3 doc builders
      getPdfStyles(){
        return {
          header: { fontSize: 14, bold: true, margin: [0, 0, 0, 10] },
          subheader: { fontSize: 12, bold: true, margin: [0, 10, 0, 6] },
          tableExample: { margin: [0, 5, 0, 15] },
          tableHeader: { bold: false, fontSize: 9, color: "black" }
        };
      },
      // -- Doc: ringkasan Metadata Kegiatan (LEGAL portrait) - mirror of IndexV2._buildDocKeg
      buildSummaryKegDoc(){
        /* const safe = (v) => {
          if (v === null || v === undefined || v === '') return '-';
          if (Array.isArray(v)) return v.map(x => (x === null || x === undefined) ? '' : String(x)).join('; ');
          return String(v);
        }; */
        // Deep clone to avoid mutating this.data
        let keg = JSON.parse(JSON.stringify(this.data || {}));
        // Safety defaults for nested objects
        keg.blok_i = keg.blok_i || {};
        keg.blok_i.alamat_instansi_penyelenggara = keg.blok_i.alamat_instansi_penyelenggara || {};
        keg.blok_ii = keg.blok_ii || {};
        keg.blok_ii.unit_penanggung_jawab = keg.blok_ii.unit_penanggung_jawab || {};
        keg.blok_ii.penanggung_jawab_teknis = keg.blok_ii.penanggung_jawab_teknis || {};
        keg.blok_iii = keg.blok_iii || {};
        keg.blok_iii.rencana_jadwal_kegiatan = keg.blok_iii.rencana_jadwal_kegiatan || {};
        keg.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan = keg.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan || [];
        keg.blok_iii.rencana_jadwal_kegiatan.desain = keg.blok_iii.rencana_jadwal_kegiatan.desain || [];
        keg.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data = keg.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data || [];
        keg.blok_iii.rencana_jadwal_kegiatan.pengolahan_data = keg.blok_iii.rencana_jadwal_kegiatan.pengolahan_data || [];
        keg.blok_iii.rencana_jadwal_kegiatan.analisis = keg.blok_iii.rencana_jadwal_kegiatan.analisis || [];
        keg.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil = keg.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil || [];
        keg.blok_iii.rencana_jadwal_kegiatan.evaluasi = keg.blok_iii.rencana_jadwal_kegiatan.evaluasi || [];
        keg.blok_iii.variabel_yang_dikumpulkan = keg.blok_iii.variabel_yang_dikumpulkan || [];
        keg.blok_iv = keg.blok_iv || {};
        keg.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data = keg.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data || [];
        keg.blok_iv.metode_pengumpulan_data = keg.blok_iv.metode_pengumpulan_data || {};
        keg.blok_iv.sarana_pengumpulan_data = keg.blok_iv.sarana_pengumpulan_data || {};
        keg.blok_iv.unit_pengumpulan_data = keg.blok_iv.unit_pengumpulan_data || {};
        keg.blok_v = keg.blok_v || {};
        keg.blok_vi = keg.blok_vi || {};
        keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data = keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data || {};
        keg.blok_vii = keg.blok_vii || {};
        keg.blok_vii.tahapan_pengolahan_data = keg.blok_vii.tahapan_pengolahan_data || {};
        keg.blok_vii.unit_analsis = keg.blok_vii.unit_analsis || {};
        keg.blok_vii.tingkat_penyajian_hasil_analisis = keg.blok_vii.tingkat_penyajian_hasil_analisis || {};
        keg.blok_viii = keg.blok_viii || {};
        keg.blok_viii.rencana_jadwal_rilis_produk_tercetak = keg.blok_viii.rencana_jadwal_rilis_produk_tercetak || [];
        keg.blok_viii.rencana_jadwal_rilis_produk_digital = keg.blok_viii.rencana_jadwal_rilis_produk_digital || [];
        keg.blok_viii.rencana_jadwal_rilis_produk_mikrodata = keg.blok_viii.rencana_jadwal_rilis_produk_mikrodata || [];

        // Helper: coerce text to string (pdfmake requires string)
        const T = (v) => (v === null || v === undefined || v === '' ? '-' : String(v));
        // Build jadwal (rencana_jadwal) date strings
        let jadwal = {
          perencanaan: [],
          desain: [],
          pengumpulan: [],
          pengolahan: [],
          analisis: [],
          diseminasi: [],
          evaluasi: []
        };
        keg.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan.forEach(x => {
          jadwal.perencanaan.push(this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir));
        });
        keg.blok_iii.rencana_jadwal_kegiatan.desain.forEach(x => {
          jadwal.desain.push(this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir));
        });
        keg.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data.forEach(x => {
          jadwal.pengumpulan.push(this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir));
        });
        keg.blok_iii.rencana_jadwal_kegiatan.pengolahan_data.forEach(x => {
          jadwal.pengolahan.push(this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir));
        });
        keg.blok_iii.rencana_jadwal_kegiatan.analisis.forEach(x => {
          jadwal.analisis.push(this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir));
        });
        keg.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil.forEach(x => {
          jadwal.diseminasi.push(this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir));
        });
        keg.blok_iii.rencana_jadwal_kegiatan.evaluasi.forEach(x => {
          jadwal.evaluasi.push(this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir));
        });

        // Body table utama: header rows + Blok I, II, III
        const body = [
          [
            { text: "Judul Kegiatan",  colSpan: 3 }, "", "",
            { text: T(keg.judul_kegiatan), colSpan: 3 }, "",  ""
          ],
          [
            { text: "Tahun",    colSpan: 3 }, "", "",
            { text: T(keg.tahun),  colSpan: 3 }, "", ""
          ],
          [
            { text: "Jenis Statistik", colSpan: 3 }, "",  "",
            { text: this.capitalize(keg.jenis_statistik), colSpan: 3 }, "", ""
          ],
          [
            { text: "Cara Pengumpulan Data", colSpan: 3 }, "", "",
            { text: this.capitalize(keg.cara_pengumpulan_data), colSpan: 3 }, "", ""
          ],
          [
            { text: "Identitas Rekomendasi:", colSpan: 3 }, "", "",
            { text: (keg.identitas_rekomendasi ? keg.identitas_rekomendasi : '-'), colSpan: 3 }, "", ""
          ],
          [
            { text: "I. Penyelenggara", fillColor: "#EEEEEE", colSpan: 6 }, "", "", "", "", ""
          ],
          [
            "1.1", { text: "Instansi Penyelenggara", colSpan: 2 }, "",
            { text: T(keg.blok_i.instansi_penyelanggara), colSpan: 3 }, "", ""
          ],
          [
            "1.2", { text: "Alamat", colSpan: 2 }, "",
            { text: T(keg.blok_i.alamat_instansi_penyelenggara.alamat), colSpan: 3 }, "", ""
          ],
          [
            "1.3", { text: "Telepon", colSpan: 2 }, "",
            { text: T(keg.blok_i.alamat_instansi_penyelenggara.telepon), colSpan: 3 }, "", ""
          ],
          [
            "1.4", { text: "Faksimile", colSpan: 2 }, "",
            { text: T(keg.blok_i.alamat_instansi_penyelenggara.faksimile), colSpan: 3 }, "", ""
          ],
          [
            "1.5", { text: "Email", colSpan: 2 }, "",
            { text: T(keg.blok_i.alamat_instansi_penyelenggara.email), colSpan: 3 }, "", ""
          ],
          [
            { text: "II. Penanggung Jawab", colSpan: 6, fillColor: "#EEEEEE" }, "", "", "", "", ""
          ],
          [
            { text: "2.1", rowSpan: 3 }, { text: "Unit Eselon Penanggung Jawab", colSpan: 5 }, "", "", "", ""
          ],
          [
            "", { text: "Eselon 1", colSpan: 2 }, "",
            { text: T(keg.blok_ii.unit_penanggung_jawab.eselon1), colSpan: 3 }, "", ""
          ],
          [
            "", { text: "Eselon 2", colSpan: 2 }, "",
            { text: T(keg.blok_ii.unit_penanggung_jawab.eselon2), colSpan: 3 }, "", ""
          ],
          [
            { text: "2.2", rowSpan: 7 }, { text: "Penanggung Jawab Teknis (setingkat Eselon 3)", colSpan: 5 }, "", "", "", ""
          ],
          [
            "", { text: "Nama ", colSpan: 2 }, "",
            { text: T(keg.blok_ii.penanggung_jawab_teknis.nama), colSpan: 3 }, "", ""
          ],
          [
            "", { text: "Jabatan ", colSpan: 2 }, "",
            { text: T(keg.blok_ii.penanggung_jawab_teknis.jabatan), colSpan: 3 }, "", ""
          ],
          [
            "", { text: "Alamat ", colSpan: 2 }, "",
            { text: T(keg.blok_ii.penanggung_jawab_teknis.alamat), colSpan: 3 }, "", ""
          ],
          [
            "", { text: "Telepon ", colSpan: 2 }, "",
            { text: T(keg.blok_ii.penanggung_jawab_teknis.telepon), colSpan: 3 }, "", ""
          ],
          [
            "", { text: "Faksimile ", colSpan: 2 }, "",
            { text: T(keg.blok_ii.penanggung_jawab_teknis.faksimile), colSpan: 3 }, "", ""
          ],
          [
            "", { text: "Email ", colSpan: 2 }, "",
            { text: T(keg.blok_ii.penanggung_jawab_teknis.email), colSpan: 3 }, "", ""
          ],
          [
            { text: "III. Perencanaan dan Persiapan", colSpan: 6, fillColor: "#EEEEEE" }, "", "", "", "", ""
          ],
          [
            "3.1", { text: "Latar Belakang Kegiatan", colSpan: 2 }, "",
            { text: T(keg.blok_iii.latar_belakang_kegiatan), colSpan: 3 }, "", ""
          ],
          [
            "3.2", { text: "Tujuan Kegiatan ", colSpan: 2 }, "",
            { text: T(keg.blok_iii.tujuan_kegiatan), colSpan: 3 }, "", ""
          ],
          [
            { text: "3.3", rowSpan: 12 }, { text: "Rencana Jadwal Kegiatan", colSpan: 5 }, "", "", "", ""
          ],
          ["", { text: "A. Perencanaan", colSpan: 5 }, "", "", "", ""],
          ["", "1", "Perencanaan Kegiatan", { ul: jadwal.perencanaan, colSpan: 3 }, "", ""],
          ["", "2", "Desain", { ul: jadwal.desain, colSpan: 3 }, "", ""],
          ["", { text: "B. Pengumpulan", colSpan: 5 }, "", "", "", ""],
          ["", "3", "Pengumpulan Data", { ul: jadwal.pengumpulan, colSpan: 3 }, "", ""],
          ["", { text: "C. Pemeriksaan", colSpan: 5 }, "", "", "", ""],
          ["", "4", "Pengolahan Data", { ul: jadwal.pengolahan, colSpan: 3 }, "", ""],
          ["", { text: "D. Penyebarluasan", colSpan: 5 }, "", "", "", ""],
          ["", "5", "Analisis Data", { ul: jadwal.analisis, colSpan: 3 }, "", ""],
          ["", "6", "Diseminasi Hasil", { ul: jadwal.diseminasi, colSpan: 3 }, "", ""],
          ["", "7", "Evaluasi", { ul: jadwal.evaluasi, colSpan: 3 }, "", ""]
        ];

        // Variabel (3.4) table
        const varsBody = [];
        varsBody.push([
          { text: "No", fillColor: "#EEEEEE" },
          { text: "Nama Variabel (Karakteristik)", fillColor: "#EEEEEE" },
          { text: "Konsep", fillColor: "#EEEEEE" },
          { text: "Definisi", fillColor: "#EEEEEE" },
          { text: "Referensi Waktu (Periode Enumerasi)", fillColor: "#EEEEEE" }
        ]);
        keg.blok_iii.variabel_yang_dikumpulkan.forEach((x, index) => {
          varsBody.push([
            { text: String(index + 1), alignment: "center" },
            { text: T(x.nama) },
            { text: T(x.konsep) },
            { text: T(x.definisi) },
            { text: T(x.referensi_waktu) }
          ]);
        });

        // nextBody: Blok IV, V, VI, VII, VIII
        let nextBody = [
          [
            { text: "IV. Desain Kegiatan", colSpan: 6, fillColor: "#EEEEEE" }, "", "", "", "", ""
          ],
          [
            "4.1", "Kegiatan ini dilakukan",
            { colSpan: 4, text: this.capitalize(keg.blok_iv.kegiatan_ini_dilakukan) }, "", "", ""
          ],
          [
            "4.2", "Frekuensi Penyelenggaraan",
            { text: this.capitalize(keg.blok_iv.frekuensi_penyelanggara), colSpan: 4 }, "", "", ""
          ],
          [
            "4.3", "Tipe Pengumpulan Data",
            { text: this.capitalize(keg.blok_iv.tipe_pengumpulan_data), colSpan: 4 }, "", "", ""
          ],
          [
            "4.4", "Cakupan Wilayah Pengumpulan Data",
            { text: this.capitalize(keg.blok_iv.cakupan_wilayah_pengumpulan_data), colSpan: 4 }, "", "", ""
          ]
        ];
        if (keg.blok_iv.cakupan_wilayah_pengumpulan_data !== "SELURUH_WILAYAH_INDONESIA") {
          nextBody.push(
            [
              { text: "4.5", rowSpan: keg.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data.length + 2 },
              { text: "Wilayah Kegiatan", colSpan: 5 }, "", "", "", ""
            ],
            ["", "Provinsi", { text: "Kabupaten/Kota", colSpan: 4 }, "", "", ""]
          );
          keg.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data.forEach(wil => {
            nextBody.push([
              "", T(wil.nama_provinsi || wil.provinsi),
              { text: T(wil.nama_kabupaten_kota || wil.kabupaten_kota), colSpan: 4 }, "", "", ""
            ]);
          });
        }
        nextBody = nextBody.concat([
          [
            { text: "4.6", rowSpan: 6 }, { text: "Metode Pengumpulan Data", colSpan: 5 }, "", "", "", ""
          ],
          [ "", "Wawancara", { text: keg.blok_iv.metode_pengumpulan_data.wawancara ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Mengisi kuesioner sendiri (swacacah)", { text: keg.blok_iv.metode_pengumpulan_data.mengisi_kuesioner_sendiri ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Pengamatan (observasi)", { text: keg.blok_iv.metode_pengumpulan_data.pengamatan ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Pengumpulan data sekunder", { text: keg.blok_iv.metode_pengumpulan_data.pengumpulan_data_sekunder ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Lainnya", { text: keg.blok_iv.metode_pengumpulan_data.lainnya ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

          [
            { text: "4.7", rowSpan: 8 }, { text: "Sarana Pengumpulan Data", colSpan: 5 }, "", "", "", ""
          ],
          [ "", "Paper-assisted Personal Interviewing (PAPI)", { text: keg.blok_iv.sarana_pengumpulan_data.papi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Computer-assisted Personal Interviewing (CAPI)", { text: keg.blok_iv.sarana_pengumpulan_data.capi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Computer-assisted Telephones Interviewing (CATI)", { text: keg.blok_iv.sarana_pengumpulan_data.cati ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Computer Aided Web Interviewing (CAWI)", { text: keg.blok_iv.sarana_pengumpulan_data.cawi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Mail", { text: keg.blok_iv.sarana_pengumpulan_data.mail ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Lainnya", { text: keg.blok_iv.sarana_pengumpulan_data.lainnya ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

          [
            { text: "4.8", rowSpan: 5 }, { text: "Unit Pengumpulan Data", colSpan: 5 }, "", "", "", ""
          ],
          [ "", "Individu", { text: keg.blok_iv.unit_pengumpulan_data.individu ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Rumah Tangga", { text: keg.blok_iv.unit_pengumpulan_data.rumah_tangga ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Usaha/Perusahaan", { text: keg.blok_iv.unit_pengumpulan_data.usaha_atau_perusahaan ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Lainnya", { text: keg.blok_iv.unit_pengumpulan_data.lainnya ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ]
        ]);

        if (keg.cara_pengumpulan_data === "SURVEI") {
          nextBody = nextBody.concat([
            [{ text: "V. Desain Sampel", colSpan: 6, fillColor: "#EEEEEE" }, "", "", "", "", ""],
            [ "5.1", "Jenis Rancangan Sampel", { text: this.capitalize(keg.blok_v.jenis_rancangan_sampel), colSpan: 4 }, "", "", "" ],
            [ "5.2", "Metode Pemilihan Sampel Tahap Terakhir", { text: this.capitalize(keg.blok_v.metode_pemilihan_sampel_tahap_terakhir), colSpan: 4 }, "", "", "" ],
            [ "5.3", "Metode Sampel Probabilitas yang digunakan", { text: this.capitalize(keg.blok_v.metode_yang_digunakan), colSpan: 4 }, "", "", "" ],
            [ "5.4", "Kerangka Sampel Tahap Terakhir", { text: this.capitalize(keg.blok_v.kerangka_sampel_tahap_terakhir), colSpan: 4 }, "", "", "" ],
            [ "5.5", "Fraksi Sampel Keseluruhan", { text: this.capitalize(keg.blok_v.fraksi_sampel_keseluruhan), colSpan: 4 }, "", "", "" ],
            [ "5.6", "Nilai Perkiraan Sampling Error Variabel Utama", { text: this.capitalize(keg.blok_v.nilai_perkiraan_sampling_error_variabel_utama), colSpan: 4 }, "", "", "" ],
            [ "5.7", "Unit Sampel", { text: this.capitalize(keg.blok_v.unit_sampel), colSpan: 4 }, "", "", "" ],
            [ "5.8", "Unit Observasi", { text: this.capitalize(keg.blok_v.unit_observasi), colSpan: 4 }, "", "", "" ]
          ]);
        }

        nextBody = nextBody.concat([
          [{ text: "VI. Pengumpulan Data", colSpan: 6, fillColor: "#EEEEEE" }, "", "", "", "", ""],
          [ "6.1", "Apakah Melakukan Uji Coba (Pilot Survey)?", { text: keg.blok_vi.apakah_melakukan_uji_coba ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

          [
            { text: "6.2", rowSpan: 5 }, { text: "Metode Pemeriksaan Kualitas Pengumpulan Data", colSpan: 5 }, "", "", "", ""
          ],
          [ "", "Kunjungan kembali (revisit)", { text: keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.kunjungan_kembali ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Supervisi", { text: keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.supervisi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Task Force", { text: keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.taskforce ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Lainnya", { text: keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.lainnya ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

          [ "6.3", "Apakah Melakukan Penyesuaian Nonrespon?", { text: keg.blok_vi.apakah_melakukan_penyesuaian_nonrespon ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "6.4", "Petugas Pengumpulan Data", { text: this.capitalize(keg.blok_vi.petugas_pengumpulan_data), colSpan: 4 }, "", "", "" ],
          [ "6.5", "Persyaratan Pendidikan Terendah Petugas Pengumpulan Data", { text: this.capitalize(keg.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data), colSpan: 4 }, "", "", "" ],

          [
            { text: "6.6", rowSpan: 3 }, { text: "Jumlah Petugas", colSpan: 5 }, "", "", "", ""
          ],
          [ "", "Supervisor/penyelia/pengawas", { text: T(keg.blok_vi.jumlah_petugas_supervisor), colSpan: 4 }, "", "", "" ],
          [ "", "Pengumpul data/enumerator", { text: T(keg.blok_vi.jumlah_petugas_enumerator), colSpan: 4 }, "", "", "" ],

          [ "6.7", "Apakah Melakukan Pelatihan Petugas?", { text: keg.blok_vi.apakah_melakukan_pelatihan_petugas ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

          [{ text: "VII. Pengolahan dan Analisis", colSpan: 6, fillColor: "#EEEEEE" }, "", "", "", "", ""],
          [
            { text: "7.1", rowSpan: 5 }, { text: "Tahapan Pengolahan Data", colSpan: 5 }, "", "", "", ""
          ],
          [ "", "Penyuntingan (Editing)", { text: keg.blok_vii.tahapan_pengolahan_data.editing ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Penyandian (Coding)", { text: keg.blok_vii.tahapan_pengolahan_data.coding ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Data Entry", { text: keg.blok_vii.tahapan_pengolahan_data.data_entry ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Penyahihan (Validasi)", { text: keg.blok_vii.tahapan_pengolahan_data.validasi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

          [ "7.2", "Metode Analisis", { text: this.capitalize(keg.blok_vii.metode_analisis), colSpan: 4 }, "", "", "" ],
          [
            { text: "7.3", rowSpan: 5 }, { text: "Unit Analisis", colSpan: 5 }, "", "", "", ""
          ],
          [ "", "Individu", { text: keg.blok_vii.unit_analsis.individu ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Rumah Tangga", { text: keg.blok_vii.unit_analsis.rumah_tangga ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Usaha/Perusahaan", { text: keg.blok_vii.unit_analsis.usaha_atau_perusahaan ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Lainnya", { text: keg.blok_vii.unit_analsis.lainnya ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

          [
            { text: "7.4", rowSpan: 6 }, { text: "Tingkat Penyajian Hasil Analisis", colSpan: 5 }, "", "", "", ""
          ],
          [ "", "Nasional", { text: keg.blok_vii.tingkat_penyajian_hasil_analisis.nasional ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Provinsi", { text: keg.blok_vii.tingkat_penyajian_hasil_analisis.provinsi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Kabupaten/Kota", { text: keg.blok_vii.tingkat_penyajian_hasil_analisis.kabupaten_atau_kota ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Kecamatan", { text: keg.blok_vii.tingkat_penyajian_hasil_analisis.kecamatan ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Lainnya", { text: T(keg.blok_vii.tingkat_penyajian_hasil_analisis.tingkat_penyajian_hasil_analisis_lainnya), colSpan: 4 }, "", "", "" ],

          [{ text: "VIII. Diseminasi Hasil", colSpan: 6, fillColor: "#EEEEEE" }, "", "", "", "", ""],
          [
            { text: "8.1", rowSpan: 4 }, { text: "Produk Kegiatan yang Tersedia untuk Umum", colSpan: 5 }, "", "", "", ""
          ],
          [ "", "Tercetak (Hardcopy)", { text: keg.blok_viii.ketersediaan_produk_tercetak ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Digital (Hardcopy)", { text: keg.blok_viii.ketersediaan_produk_digital ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
          [ "", "Data Mikro", { text: keg.blok_viii.ketersediaan_produk_mikrodata ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

          [
            { text: "8.2", rowSpan: 4 }, { text: "Rencana Rilis Produk Kegiatan", colSpan: 5 }, "", "", "", ""
          ],
          [
            "", "Tercetak (Hardcopy)",
            {
              ul: keg.blok_viii.rencana_jadwal_rilis_produk_tercetak.map(x => this.dateFormatter(x)),
              colSpan: 4
            }, "", "", ""
          ],
          [
            "", "Digital (Hardcopy)",
            {
              ul: keg.blok_viii.rencana_jadwal_rilis_produk_digital.map(x => this.dateFormatter(x)),
              colSpan: 4
            }, "", "", ""
          ],
          [
            "", "Data Mikro",
            {
              ul: keg.blok_viii.rencana_jadwal_rilis_produk_mikrodata.map(x => this.dateFormatter(x)),
              colSpan: 4
            }, "", "", ""
          ]
        ]);

        return {
          pageSize: "LEGAL",
          pageOrientation: "portrait",
          pageMargins: [20, 30, 20, 30],
          content: [
            { text: "Rekapitulasi Metadata Statistik Kegiatan", alignment: "center", style: "header" },
            {
              style: "tableExample",
              widths: ["auto", "auto", "auto", "auto", "auto", "*"],
              table: { body: body }
            },
            {
              text: "3.4. Variabel (Karakteristik) yang Dikumpulkan:",
              alignment: "left",
              style: "subheader"
            },
            {
              style: "tableExample",
              table: {
                headerRows: 1,
                widths: [20, "auto", "auto", "auto", "auto"],
                body: varsBody
              }
            },
            {
              style: "tableExample",
              widths: ["auto", "auto", "auto", "auto", "auto", "*"],
              table: { body: nextBody }
            }
          ],
          styles: {
            header: { fontSize: 18, bold: true, margin: [0, 0, 0, 10] },
            subheader: { fontSize: 10, bold: true, margin: [0, 10, 0, 5] },
            tableExample: { margin: [0, 5, 0, 15], fontSize: 9, color: "black", bold: false },
            tableHeader: { bold: false, fontSize: 9, color: "black" }
          },
          defaultStyle: { fontSize: 9 }
        };
      },
      // -- Doc: ringkasan Metadata Variabel (A3 landscape) - mirror of IndexV2._buildDocVar
      buildSummaryVarDoc(){
        const T = (v) => (v === null || v === undefined || v === '' ? '-' : String(v));
        let body = [];
        let column = [
          { text: "No", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Nama Variabel", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Alias", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Definisi", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Konsep", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Referensi Pemilihan", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Referensi Waktu", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Ukuran", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Satuan", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Tipe Data", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Klasifikasi Isian", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Aturan Validasi", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Kalimat Pertanyaan", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Apakah dapat diakses umum", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" }
        ];
        body.push(column);
        const exportedVars = this.exportedVars || [];
        exportedVars.forEach((x, index) => {
          // Safety defaults
          x.referensi_pemilihan = x.referensi_pemilihan || [];
          x.value_domain = x.value_domain || [];
          x.aturan_validasi = x.aturan_validasi || [];
          x.konsep = x.konsep || [];

          let referensi_pemilihan = [];
          x.referensi_pemilihan.forEach(ref => {
            // ref may be a string (v1 mapper) or object {nama} (v2)
            if (typeof ref === 'string') {
              referensi_pemilihan.push(ref);
            } else if (ref && ref.nama) {
              referensi_pemilihan.push(ref.nama);
            }
          });

          let klasifikasi_isian = [];
          x.value_domain.forEach(val_dom => {
            if (val_dom) {
              klasifikasi_isian.push(T(val_dom.kode) + " = " + T(val_dom.nilai));
            }
          });

          let aturan_validasi = [];
          x.aturan_validasi.forEach(validasi => {
            aturan_validasi.push(T(validasi));
          });

          body.push([
            { text: (index + 1).toString(), alignment: "center" },
            T(x.nama),
            T(x.alias),
            T(x.definisi),
            x.konsep.length > 0 ? { ul: x.konsep.map(k => T(k)) } : '-',
            referensi_pemilihan.length > 0 ? { ul: referensi_pemilihan } : '-',
            T(x.referensi_waktu),
            T(x.ukuran),
            T(x.satuan),
            T(x.tipe_data),
            klasifikasi_isian.length > 0 ? { ul: klasifikasi_isian } : '-',
            aturan_validasi.length > 0 ? { ul: aturan_validasi } : '-',
            T(x.kalimat_pertanyaan),
            {
              text: x.apakah_variabel_bisa_diakses_umum ? "Ya" : "Tidak",
              alignment: "center"
            }
          ]);
        });
        return {
          pageSize: "A3",
          pageOrientation: "landscape",
          pageMargins: [20, 30, 20, 30],
          content: [
            { text: "Rekapitulasi Metadata Statistik Variabel", alignment: "center", style: "header" },
            {
              style: "tableExample",
              table: {
                headerRows: 1,
                widths: [
                  15,  // no
                  "*",  // nama
                  40,   // alias
                  120,  // definisi
                  "*",  // konsep
                  "*",  // referensi_pemilihan
                  80,   // referensi_waktu
                  60,   // ukuran
                  60,   // satuan
                  60,   // tipe_data
                  100,  // klasifikasi_isian
                  "*",  // aturan_validasi
                  100,  // kalimat_pertanyaan
                  30    // apakah_variabel_bisa_diakses_umum
                ],
                body: body
              }
            }
          ],
          styles: {
            header: { fontSize: 18, bold: true, margin: [0, 0, 0, 10] },
            subheader: { fontSize: 16, bold: true, margin: [0, 10, 0, 5] },
            tableExample: { margin: [0, 5, 0, 15], fontSize: 9, color: "black", bold: false },
            tableHeader: { bold: false, fontSize: 9, color: "black" }
          },
          defaultStyle: { fontSize: 9 }
        };
      },
      // -- Doc: ringkasan Metadata Indikator (LEGAL landscape) - mirror of IndexV2._buildDocInd
      buildSummaryIndDoc(){
        const T = (v) => (v === null || v === undefined || v === '' ? '-' : String(v));
        let body = [];
        let firstColumn = [
          { text: "No", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Nama Indikator", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Definisi", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Konsep", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Interpretasi", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Metode Perhitungan", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Ukuran", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Satuan", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Klasifikasi Penyajian", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Apakah Indikator Komposit", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Indikator Pembangun", style: "tableHeader", colSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          {},
          { text: "Variabel Pembangun", style: "tableHeader", colSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          {},
          { text: "Level Estimasi", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" },
          { text: "Apakah dapat diakses umum", style: "tableHeader", rowSpan: 2, alignment: "center", fillColor: "#EEEEEE" }
        ];
        let secondColumn = [
          {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
          { text: "Publikasi Ketersediaan", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Nama", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Kegiatan Penghasil", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          { text: "Nama", style: "tableHeader", alignment: "center", fillColor: "#EEEEEE" },
          {}, {}
        ];
        body.push(firstColumn);
        body.push(secondColumn);
        const exportedInds = this.exportedInds || [];
        exportedInds.forEach((x, index) => {
          // Safety defaults
          x.variabel_disaggregasi = x.variabel_disaggregasi || [];
          x.indikator_pembangun = x.indikator_pembangun || [];
          x.variabel_pembangun = x.variabel_pembangun || [];

          let variabel_disaggregasi = [];
          x.variabel_disaggregasi.forEach(disaggregasi => {
            if (disaggregasi && disaggregasi.nama) {
              variabel_disaggregasi.push(disaggregasi.nama);
            }
          });

          let ketersediaan_publikasi_indikator_pembangun = [];
          let nama_indikator_pembangun = [];
          let kegiatan_penghasil_variabel_pembangun = [];
          let nama_variabel_pembangun = [];
          if (x.apakah_indikator_komposit) {
            x.indikator_pembangun.forEach(ind => {
              ind.sumber_publikasi = ind.sumber_publikasi || [];
              if (ind.sumber_publikasi.length > 0) {
                ketersediaan_publikasi_indikator_pembangun.push(...ind.sumber_publikasi);
              }
            });
            x.indikator_pembangun.forEach(ind => {
              nama_indikator_pembangun.push(ind.nama || '-');
            });
          } else {
            x.variabel_pembangun.forEach(variabel => {
              variabel.kegiatan_penghasil = variabel.kegiatan_penghasil || [];
              if (variabel.kegiatan_penghasil.length > 0) {
                kegiatan_penghasil_variabel_pembangun.push(...variabel.kegiatan_penghasil);
              }
            });
            x.variabel_pembangun.forEach(variabel => {
              nama_variabel_pembangun.push(variabel.nama || '-');
            });
          }
          body.push([
            { text: (index + 1).toString(), alignment: "center" },
            T(x.nama),
            T(x.definisi),
            T(x.konsep),
            T(x.interpretasi),
            T(x.metode_perhitungan),
            T(x.ukuran),
            T(x.satuan),
            variabel_disaggregasi.length > 0 ? { ul: variabel_disaggregasi } : '-',
            x.apakah_indikator_komposit ? "Ya" : "Tidak",
            ketersediaan_publikasi_indikator_pembangun.length > 0 ? { ol: ketersediaan_publikasi_indikator_pembangun } : '-',
            nama_indikator_pembangun.length > 0 ? { ol: nama_indikator_pembangun } : '-',
            kegiatan_penghasil_variabel_pembangun.length > 0 ? { ol: kegiatan_penghasil_variabel_pembangun } : '-',
            nama_variabel_pembangun.length > 0 ? { ol: nama_variabel_pembangun } : '-',
            T(x.level_estimasi),
            {
              text: x.apakah_indikator_bisa_diakses_umum ? "Ya" : "Tidak",
              alignment: "center"
            }
          ]);
        });
        return {
          pageSize: "LEGAL",
          pageOrientation: "landscape",
          pageMargins: [20, 30, 20, 30],
          content: [
            { text: "Rekapitulasi Metadata Statistik Indikator", alignment: "center", style: "header" },
            {
              style: "tableExample",
              table: {
                headerRows: 2,
                body: body
              }
            }
          ],
          styles: {
            header: { fontSize: 18, bold: true, margin: [0, 0, 0, 10] },
            subheader: { fontSize: 16, bold: true, margin: [0, 10, 0, 5] },
            tableExample: { margin: [0, 5, 0, 15], fontSize: 9, color: "black", bold: false },
            tableHeader: { bold: false, fontSize: 9, color: "black" }
          },
          defaultStyle: { fontSize: 9 }
        };
      },
      updateMsVarV1Structure(variable){
        return  {
          nama: variable.nama ? variable.nama : null,
          alias: variable.alias ? variable.alias : null,
          konsep: Array.isArray(variable.konsep) ? variable.konsep : (variable.konsep ? [variable.konsep] : []),
          definisi: variable.definisi ? variable.definisi : null,
          referensi_pemilihan: variable.referensiPemilihan && variable.referensiPemilihan.length>0 ? variable.referensiPemilihan.map(x=>x.nama) : [],
          referensi_waktu: variable.referensiWaktu ? variable.referensiWaktu : null,
          ukuran: variable.ukuran ? variable.ukuran : null,
          satuan: variable.satuan ? variable.satuan : null,
          tipe_data: variable.tipeData ? variable.tipeData : null,
          value_domain: variable.valueDomain && variable.valueDomain.length>0 ? variable.valueDomain : [],
          aturan_validasi: variable.aturanValidasi && variable.aturanValidasi.length >0 ? variable.aturanValidasi : [],
          kalimat_pertanyaan: variable.kalimatPertanyaan ? variable.kalimatPertanyaan : null,
          apakah_variabel_bisa_diakses_umum: variable.apakahVariabelBisaDiaksesUmum ? variable.apakahVariabelBisaDiaksesUmum : null,
          id_sds: null,
        };
      },
      updateMsIndV1Structure(indikator){
        return {
          nama: indikator.nama ? indikator.nama : null,
          definisi: indikator.definisi ? indikator.definisi : null,
          konsep: indikator.konsep ? [indikator.konsep] : [],
          interpretasi: indikator.interpretasi ? indikator.interpretasi : null,
          metode_perhitungan: indikator.metodeAtauRumusPerhitungan ? indikator.metodeAtauRumusPerhitungan : null,
          rumus: null,
          ukuran: indikator.ukuran ? indikator.ukuran : null,
          satuan: indikator.satuan ? indikator.satuan : null,
          variabel_disaggregasi: indikator.variabelDisaggregasi && indikator.variabelDisaggregasi.length>0 ? indikator.variabelDisaggregasi : [null],
          apakah_indikator_komposit: indikator.apakahIndikatorKomposit ? indikator.apakahIndikatorKomposit : null,
          indikator_pembangun: indikator.indikatorPembangun && indikator.indikatorPembangun.length>0 ? indikator.indikatorPembangun.map(x=>({
              nama: x.nama,
              sumber_publikasi: x.ketersediaanPublikasi.map(x=>x.nama)
            })
          ) : [],
          variabel_pembangun: indikator.variabelPembangun && indikator.variabelPembangun.length>0 ? indikator.variabelPembangun.map(x=>({
              nama: x.nama,
              kegiatan_penghasil: x.kegiatanPenghasil
            })
          ) : [],
          level_estimasi: indikator.levelEstimasi ? indikator.levelEstimasi : null,
          apakah_indikator_bisa_diakses_umum: indikator.apakahIndikatorBisaDiaksesUmum ? indikator.apakahIndikatorBisaDiaksesUmum : null,
          id_sds: null
        };
      },
      capitalize(sentence){
        return sentence ? sentence.replaceAll('_',' ').replace(/_./g, ' ').toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-';
      },
      dateFormatter(stringDate) {
        if (stringDate == null) {
          return "";
        } else {
          moment.locale("id");
          return moment(stringDate).format("LL");
        }
      },
      getBadge(type) {
        if (type === "DRAFT") {
          return '<span class="status status--draft">Draft</span>';
        } else if (type === "APPROVED") {
          return '<span class="status status--approved">Disetujui</span>';
        } else if (type === "REVISED") {
          return '<span class="status status--revised">Sudah Diperbaiki</span>';
        } else if (type === "REJECTED") {
          return '<span class="status status--rejected">Ditolak</span>';
        } else if (type === "UNDER_REVIEW") {
          return '<span class="status status--review">Sedang Diperiksa</span>';
        } else if (type === "CORRECTION_REQUIRED") {
          return '<span class="status status--correction">Perlu Perbaikan</span>';
        } else if (type === "SUBMITTED") {
          return '<span class="status status--submitted">Submit</span>';
        }
      },
      async deleteMsKeg() {
        await MsService.deleteMsKegById(this.deletedId).then(
          (result) => {
            this.$bvModal.hide('modal-delete');
            let response = result.data.result[0];
            if(response==null){
              this.getSummaryMetadata();
            }
            else{
              if(response.status == 403){
                this.modal.error.title = 'Delete Item Gagal';
                this.modal.error.description = 'Anda hanya dapat menghapus item yang berstatus DRAFT saja';
              }
              else{
                this.modal.error.title = response.title;
                this.modal.error.description = response.detail;
              }
              this.$bvModal.show('modal-error');
            }
          },
          (error) => {
              console.log(error);
          }
        );
      },
      notif(title, content, type) {
        swal.fire(title, content, type);
      },
      warningEdit() {
        this.notif(
          "Isian tidak dapat diubah",
          "Anda hanya dapat mengedit isian dengan status DRAFT dan CORRECTION_REQUIRED !",
          "warning"
        );
      },
      warningDelete() {
        this.notif(
          "Isian tidak dapat dihapus",
          "Anda hanya dapat menghapus isian dengan status DRAFT!",
          "warning"
        );
      },
      filterModal() {
        this.$bvModal.show("filter-modal");
      },
      doFilter() {
        alert("hahaha");
      },
      isCreatedByMe(item){
        return !!(item.requested_by == this.$store.getters['auth/user'].username || role.isSuperAdmin(this.userRoles));
      },
      editTooltip(item){
        if(item.status == 'DRAFT' || item.status == 'CORRECTION_REQUIRED'){
          if(item.requested_by == this.user.username || 
            item.produsen_data_id == this.user.organization.id || 
            item.produsen_data_name == this.user.organization.name || 
            item.requester_organization_id == this.user.organization.id || 
            role.isWalidata([this.current_role])
          ){
            return 'Edit';
          }
          else{
            return 'Anda tidak bisa mengedit laporan milik Produsen Data lain'
          }
        }else{
          return 'Anda hanya bisa mengedit laporan yang berstatus Draft atau Perlu Perbaikan'
        }
      },
      editDisabled(item){
        if(item.status == 'DRAFT' || item.status == 'CORRECTION_REQUIRED'){
          if(item.requested_by == this.user.username){
            return false;
          }
          else if(item.produsen_data_id == this.user.organization.id || item.produsen_data_name == this.user.organization.name){
            return false;
          }
          else if(item.requester_organization_id == this.user.organization.id){
            return false;
          }else if(role.isWalidata([this.current_role])){
            return false
          }
          else{
            return true;
          }
        }else{
          return true
        }
      },
      deleteTooltip(item){
        if(item.status == 'DRAFT'){
          if(item.requested_by == this.user.username || (item.produsen_data_id == this.user.organization.id || item.produsen_data_name == this.user.organization.name )){
            return 'Delete';
          }
          else{
            return 'Anda tidak bisa menghapus laporan milik Produsen Data lain'
          }
        }else{
          return 'Anda hanya bisa menghapus laporan yang berstatus Draft'
        }
      },
      deleteDisabled(item){
        return !(item.status == 'DRAFT' && (item.requested_by == this.user.username || (item.produsen_data_id == this.user.organization.id || item.produsen_data_name == this.user.organization.name)));
        
      },
    },
    
  };
  </script>
  